import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'typed-redux-saga';

import { SidebarContent } from '../../types';
import { updateQuery } from './slice';

export function* clearSearchQueryOnParticipantsCloseSaga({ payload }: PayloadAction<SidebarContent | null>) {
    if (payload !== SidebarContent.Participants) {
        yield* put(updateQuery(''));
    }
}
